import './App.css';

import React, { useEffect } from "react";
import { logoutUser } from './js/helper';

import { Welcome } from './pages/Welcome';


import { DetailsPage } from './pages/DetailsPage';

import { VipDetailsPage } from './pages/VipDetailsPage';

import { LoginPage } from './pages/LoginPage'

import { MerchantPage } from './pages/MerchantPage'

import { Dashboard } from './pages/Dashboard';

import { VipCode } from './pages/VipCode';
 
import PrivateRoute from './RouteGuards/PrivateRoute';


import { HashRouter as Router,Routes, Route, Navigate } from "react-router-dom";
import PassWordChange from './pages/ChangePassword';

import { ScreenLockProvider } from './context/LeaveConfirmContext';

function sessionTimeout() {
 
  let timeoutId;
  const TIMEOUT = 3600000; // Timeout period in milliseconds (60 minutes)

  const resetTimeout = () => {
   
    clearTimeout(timeoutId);
    timeoutId = setTimeout(logoutUser, TIMEOUT);
  };

  // Attach event listeners to reset the timeout when user interacts with the page
  ["mousedown", "mousemove", "keypress", "scroll", "touchstart"].forEach((eventType) =>
    document.addEventListener(eventType, resetTimeout, false)
  );

  resetTimeout();
}
function App() {
  useEffect(() => {
    sessionTimeout();
  }, []);
  return (

    <div className="container-fluid p-0">

       <div className="App">

       <Router>
         <ScreenLockProvider>
           <Routes>
           <Route path="/*" element={<Navigate to="/" />}>
           </Route>
           <Route path="/" element={<LoginPage/>} exact>
            </Route>
            <Route path="/Add-items" element={<PrivateRoute component={Welcome}/>} exact>
            </Route>
            <Route path="/Change-Password" element={<PrivateRoute component={PassWordChange} isChangePassword={true}/>} exact>
            </Route>
            <Route path="/Item-details" element={<PrivateRoute component={DetailsPage}/>} exact>
            </Route>
            <Route path="/Vip-details" element={<PrivateRoute component={VipDetailsPage}/>} exact>
            </Route>
            <Route path="/merchantpage" element={<PrivateRoute component={MerchantPage}/>} exact>
            </Route>
            <Route path="/dashboard" element={<PrivateRoute component={Dashboard}/>} exact>
            </Route>
            <Route path="/vip-code" element={<PrivateRoute component={VipCode}/>} exact>
            </Route>
            </Routes>
         </ScreenLockProvider>
       </Router>

    </div>

    </div>

  );

} 



export default App;